import { render, staticRenderFns } from "./ExpelledAcademicVacationGrid.vue?vue&type=template&id=721bd876"
import script from "./ExpelledAcademicVacationGrid.vue?vue&type=script&lang=js"
export * from "./ExpelledAcademicVacationGrid.vue?vue&type=script&lang=js"
import style0 from "./ExpelledAcademicVacationGrid.vue?vue&type=style&index=0&id=721bd876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports